import React, { useEffect } from 'react'
import { Canvas, Column, GameCanvas, Row } from './styles/styles.js'

import {
  render,
  renderDetail,
  handleKeyUp,
  handleMouseEnterWithCanvas,
  handleMouseLeaveWithCanvas,
  initialize,
} from './ball-physics'

export default () => {
  useEffect(() => {
    const gameCanvas = document.getElementById('game-canvas')
    const gameContext = gameCanvas.getContext('2d')
    const detailCanvas = document.getElementById('detail-canvas')
    const detailContext = detailCanvas.getContext('2d')
    const statusDiv = document.getElementById('status')
    const ballDiv = document.getElementById('balls')

    initialize(gameCanvas, statusDiv, ballDiv)

    const renderId = setInterval(render, 10, gameCanvas, gameContext)
    const renderDetailId = setInterval(
      renderDetail,
      10,
      detailCanvas,
      detailContext,
    )

    const handleMouseEnter = handleMouseEnterWithCanvas(gameCanvas)
    const handleMouseLeave = handleMouseLeaveWithCanvas(gameCanvas)

    document.addEventListener('keyup', handleKeyUp)
    gameCanvas.addEventListener('mouseenter', handleMouseEnter)
    gameCanvas.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      clearInterval(renderId)
      clearInterval(renderDetailId)
      document.removeEventListener('keyup', handleKeyUp)
      gameCanvas.removeEventListener('mouseenter', handleMouseEnter)
      gameCanvas.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [])

  return (
    <Column id="ball-physics-content">
      <Row id="title">Ball Physics Sandbox</Row>
      <Row id="description">Click anywhere on the canvas to fire a ball from the center towards that point. The [Shift] key will allow you to add bounding walls to the box so that the balls stay inside and interact. The [Esc] key will clear all balls on the canvas. Additionally, you can click the balls below to see a detail view of an individual ball. Have fun!</Row>
      <Row id="canvas">
        <GameCanvas id="game-canvas" width="960" height="640"></GameCanvas>
      </Row>
      <Row id="detail">
        <Canvas id="detail-canvas" width="480" height="200"></Canvas>
      </Row>
      <Row id="status"></Row>
      <Row id="balls"></Row>
    </Column>
  )
}
